// Environment configuration for micro-frontend URLs
const config = {
  development: {
    // agentStudioUrl: 'http://localhost:3001',
    agentStudioUrl: 'http://studio-var80.s3-website-us-east-1.amazonaws.com/',
    mainAppUrl: 'http://localhost:3000'
  },
  production: {
    // agentStudioUrl: 'https://agent-studio.yourdomain.com',
    agentStudioUrl: 'http://studio-var80.s3-website-us-east-1.amazonaws.com/',
    mainAppUrl: 'https://app.yourdomain.com'
  }
};

const environment = process.env.NODE_ENV || 'development';

export const getConfig = () => config[environment];
export const getAgentStudioUrl = () => config[environment].agentStudioUrl;

// Helper function for opening Agent Studio in new tab with auth data
export const openAgentStudio = (authData = null) => {
  let url = getAgentStudioUrl();
  
  // Add auth data as URL parameters if provided
  if (authData) {
    const params = new URLSearchParams();
    // Encode auth data safely
    if (authData.api_key) params.set('api_key', btoa(authData.api_key));
    if (authData.first_name) params.set('first_name', btoa(authData.first_name));
    if (authData.last_name) params.set('last_name', btoa(authData.last_name));
    if (authData.token) params.set('token', btoa(authData.token));
    if (authData.email) params.set('email', btoa(authData.email));
    if (authData.userData) params.set('userData', btoa(JSON.stringify(authData.userData)));
    
    url += '?' + params.toString();
  }
  
  const newWindow = window.open(url, '_blank');
  
  // Send additional data via postMessage after window opens
  if (newWindow && authData) {
    setTimeout(() => {
      newWindow.postMessage({
        type: 'AUTH_DATA',
        data: authData
      }, getAgentStudioUrl());
    }, 1000);
  }
  
  return newWindow;
};
